import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaHeart, FaShoppingCart, FaHome } from 'react-icons/fa';
import { Helmet } from "react-helmet";

function PostDetail() {
  const { id } = useParams();
  const [showShareModal, setShowShareModal] = useState(false);
  const [showFavoriteModal, setShowFavoriteModal] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);

  const posts = {
    1: {
      title: 'Μυστικά της Τέλειας Κρέμας Patisserie',
      date: '15 Ιανουαρίου 2025',
      image: '/images/1.jpg',
      content: `
        <h2>Εισαγωγή στην Τέχνη της Κρέμας</h2>
        <p>Η κρέμα patisserie αποτελεί τη βάση αμέτρητων γαλλικών επιδορπίων και είναι ένα από τα πιο σημαντικά στοιχεία στο ρεπερτόριο κάθε ζαχαροπλάστη. Αυτή η πλούσια, βελούδινη κρέμα με βάση το γάλα και τα αυγά μπορεί να χρησιμοποιηθεί για να γεμίσει eclairs, profiteroles, τάρτες φρούτων και πολλά άλλα γλυκά.</p>

        <h3>Τα Απαραίτητα Υλικά</h3>
        <ul>
          <li>500ml πλήρες γάλα υψηλής ποιότητας</li>
          <li>100g ζάχαρη λευκή καστόρι</li>
          <li>4 μεγάλα κρόκοι αυγών από ελεύθερης βοσκής κότες</li>
          <li>40g κορν φλάουρ</li>
          <li>1 κουτάλι σούπας εκχύλισμα βανίλιας Μαδαγασκάρης</li>
          <li>30g βούτυρο αγελάδος χωρίς αλάτι</li>
        </ul>

        <h3>Βήμα προς Βήμα Διαδικασία</h3>
        <p>Αρχίστε ζεσταίνοντας το γάλα με το μισό ποσό της ζάχαρης σε μια κατσαρόλα με παχύ πάτο. Η χρήση παχύτερης κατσαρόλας εξασφαλίζει ομοιόμορφη κατανομή της θερμότητας και αποτρέπει το κάψιμο.</p>

        <p>Σε ένα ξεχωριστό μπολ, χτυπήστε τους κρόκους με την υπόλοιπη ζάχαρη μέχρι να γίνουν ανοιχτόχρωμοι και αφράτοι. Προσθέστε το κορν φλάουρ και ανακατέψτε καλά μέχρι να ενσωματωθεί πλήρως.</p>

        <h3>Η Κρίσιμη Φάση του Tempering</h3>
        <p>Όταν το γάλα αρχίσει να βράζει ελαφρά, αφαιρέστε το από τη φωτιά. Προσθέστε σταδιακά το ζεστό γάλα στο μείγμα των αυγών, ανακατεύοντας συνεχώς. Αυτή η διαδικασία, γνωστή ως tempering, είναι κρίσιμη για να αποφύγετε τη μαγείρεμα των αυγών.</p>

        <h2>Διάγραμμα Θερμοκρασίας Μαγειρέματος</h2>
        <div class="chart-container">
          <h3>Ιδανικές Θερμοκρασίες για Τέλεια Κρέμα</h3>
          <div class="chart-bars">
            <div class="chart-bar" style="height: 40%;">
              <span class="chart-value">40°C</span>
              <span class="chart-label">Έναρξη</span>
            </div>
            <div class="chart-bar" style="height: 65%;">
              <span class="chart-value">65°C</span>
              <span class="chart-label">Tempering</span>
            </div>
            <div class="chart-bar" style="height: 85%;">
              <span class="chart-value">85°C</span>
              <span class="chart-label">Πάχυνση</span>
            </div>
            <div class="chart-bar" style="height: 50%;">
              <span class="chart-value">50°C</span>
              <span class="chart-label">Βούτυρο</span>
            </div>
            <div class="chart-bar" style="height: 20%;">
              <span class="chart-value">4°C</span>
              <span class="chart-label">Ψύξη</span>
            </div>
          </div>
        </div>

        <h3>Επαγγελματικά Μυστικά</h3>
        <ul>
          <li>Χρησιμοποιείτε πάντα φρέσκα αυγά για την καλύτερη γεύση και υφή</li>
          <li>Μην αφήνετε την κρέμα να βράσει έντονα, καθώς μπορεί να χωρίσει</li>
          <li>Το σκέπασμα με μεμβράνη τροφίμων κατευθείαν στην επιφάνεια αποτρέπει τη δημιουργία πέτσας</li>
          <li>Ψύξτε γρήγορα την κρέμα τοποθετώντας το μπολ πάνω από πάγο</li>
          <li>Για επιπλέον πλούσια γεύση, προσθέστε 50ml βαριάς κρέμας γάλακτος</li>
        </ul>

        <p>Επιστρέψτε το μείγμα στην κατσαρόλα και μαγειρέψτε σε μέτρια φωτιά, ανακατεύοντας συνεχώς με σύρμα, μέχρι η κρέμα να παχύνει και να αρχίσει να βράζει ελαφρά. Αυτό συνήθως διαρκεί 2-3 λεπτά.</p>

        <h3>Τελειοποίηση και Συντήρηση</h3>
        <p>Αφαιρέστε από τη φωτιά και προσθέστε το βούτυρο και το εκχύλισμα βανίλιας, ανακατεύοντας μέχρι να ενσωματωθούν πλήρως. Μεταφέρετε την κρέμα σε καθαρό μπολ και καλύψτε την επιφάνεια με μεμβράνη τροφίμων για να αποτρέψετε τη δημιουργία πέτσας.</p>

        <p>Αφήστε την κρέμα να κρυώσει σε θερμοκρασία δωματίου για 30 λεπτά, στη συνέχεια τοποθετήστε την στο ψυγείο για τουλάχιστον 2 ώρες πριν τη χρησιμοποιήσετε. Η κρέμα μπορεί να διατηρηθεί στο ψυγείο για έως και 3 ημέρες.</p>

        <h3>Παραλλαγές και Χρήσεις</h3>
        <p>Αυτή η βασική κρέμα patisserie μπορεί να μετατραπεί σε πολλές νόστιμες παραλλαγές. Προσθέστε λιωμένη σοκολάτα για κρέμα σοκολάτας, πουρέ φρούτων για κρέμα φρούτων, ή καφέ espresso για κρέμα καφέ.</p>

        <p>Χρησιμοποιήστε την για να γεμίσετε choux pastry, να στρώσετε τάρτες, να γεμίσετε crepes, ή ως βάση για elaborate γλυκά. Η ευελιξία αυτής της κρέμας την καθιστά απαραίτητη στο ρεπερτόριο κάθε ζαχαροπλάστη.
        </p>
      `
    },
    2: {
      title: 'Τέχνη Διακόσμησης με Fondant',
      date: '12 Ιανουαρίου 2025',
      image: '/images/2.jpg',
      content: `
        <h2>Εισαγωγή στον Κόσμο του Fondant</h2>
        <p>Το fondant είναι μια ζαχαρόπαστα που έχει μετατρέψει τη διακόσμηση τούρτων σε αληθινή τέχνη. Με τη λεία, βελούδινη υφή του και την απεριόριστη δυνατότητα χειρισμού, το fondant επιτρέπει τη δημιουργία εκπληκτικών σχεδίων που μοιάζουν σχεδόν αδύνατα να επιτευχθούν με άλλα υλικά.</p>

        <h3>Βασικά Υλικά και Εργαλεία</h3>
        <ul>
          <li>Fondant υψηλής ποιότητας (κατά προτίμηση έτοιμο ή σπιτικό)</li>
          <li>Πλάστης και μαχαίρι fondant</li>
          <li>Κόφτες διαφόρων σχημάτων και μεγεθών</li>
          <li>Πινέλα τροφίμων και βρώσιμα χρώματα σε gel</li>
          <li>Άχνη ζάχαρη για πούδρα</li>
          <li>Κόλλα fondant ή βρώσιμη κόλλα</li>
          <li>Κυλινδρική βάση για άπλωμα</li>
          <li>Εργαλεία σκάλισμης και μορφοποίησης</li>
        </ul>

        <h3>Προετοιμασία του Fondant</h3>
        <p>Πριν ξεκινήσετε οποιαδήποτε εργασία, είναι σημαντικό να ζυμώσετε καλά το fondant μέχρι να γίνει μαλακό και εύπλαστο. Αυτό το βήμα είναι κρίσιμο για να αποφύγετε ρωγμές και ανομοιόμορφη επιφάνεια.</p>

        <h2>Διάγραμμα Χρόνου Εργασίας</h2>
        <div class="chart-container">
          <h3>Φάσεις Διακόσμησης Τούρτας με Fondant</h3>
          <div class="chart-bars">
            <div class="chart-bar" style="height: 30%;">
              <span class="chart-value">30min</span>
              <span class="chart-label">Προετοιμασία</span>
            </div>
            <div class="chart-bar" style="height: 45%;">
              <span class="chart-value">45min</span>
              <span class="chart-label">Κάλυψη</span>
            </div>
            <div class="chart-bar" style="height: 90%;">
              <span class="chart-value">90min</span>
              <span class="chart-label">Διακόσμηση</span>
            </div>
            <div class="chart-bar" style="height: 60%;">
              <span class="chart-value">60min</span>
              <span class="chart-label">Λεπτομέρειες</span>
            </div>
            <div class="chart-bar" style="height: 20%;">
              <span class="chart-value">20min</span>
              <span class="chart-label">Φινίρισμα</span>
            </div>
          </div>
        </div>

        <h3>Τεχνικές Χρωματισμού</h3>
        <p>Ο χρωματισμός του fondant απαιτεί υπομονή και προσοχή. Χρησιμοποιήστε πάντα χρώματα gel αντί για υγρά, καθώς τα τελευταία μπορεί να αλλάξουν την υφή του fondant. Προσθέστε το χρώμα σταδιακά, ζυμώνοντας καλά μετά από κάθε προσθήκη.</p>

        <h3>Τεχνικές Άπλωσης και Κάλυψης</h3>
        <ul>
          <li>Πασπαλίστε την επιφάνεια εργασίας με άχνη ζάχαρη</li>
          <li>Απλώστε το fondant σε κύκλο περίπου 5mm πάχος</li>
          <li>Χρησιμοποιήστε τον κύλινδρο για να το μεταφέρετε στην τούρτα</li>
          <li>Λειάνετε την επιφάνεια από το κέντρο προς τα έξω</li>
          <li>Αφαιρέστε τις πτυχές με απαλές κινήσεις</li>
          <li>Κόψτε το περίσσευμα με μαχαίρι fondant</li>
        </ul>

        <h3>Δημιουργία Διακοσμητικών Στοιχείων</h3>
        <p>Τα διακοσμητικά στοιχεία από fondant μπορούν να κυμαίνονται από απλά λουλούδια μέχρι πολύπλοκες φιγούρες. Αρχίστε με απλά σχέδια και σταδιακά προχωρήστε σε πιο σύνθετα.</p>

        <p>Για λουλούδια, χρησιμοποιήστε κόφτες σε σχήμα πέταλων και αφήστε τα να στεγνώσουν σε κυρτές επιφάνειες για να αποκτήσουν φυσική καμπύλη. Για φιγούρες, χτίστε από τη βάση προς τα πάνω, χρησιμοποιώντας οδοντογλυφίδες ή σύρματα για υποστήριξη.</p>

        <h3>Προηγμένες Τεχνικές</h3>
        <p>Όταν αποκτήσετε εμπειρία, μπορείτε να πειραματιστείτε με τεχνικές όπως το marbling, το ruffling, και τη δημιουργία τρισδιάστατων σχεδίων. Η πρακτική είναι το κλειδί για την τελειοποίηση αυτών των δεξιοτήτων.</p>

        <h3>Συμβουλές Διατήρησης</h3>
        <p>Οι τούρτες με fondant πρέπει να φυλάσσονται σε δροσερό, ξηρό μέρος, μακριά από άμεσο ηλιακό φως. Αποφύγετε το ψυγείο, καθώς η υγρασία μπορεί να προκαλέσει λύωμα και απώλεια της γυαλάδας του fondant.</p>

        <p>Με υπομονή, πρακτική και προσοχή στη λεπτομέρεια, το fondant μπορεί να μετατραπεί από απλό υλικό σε εντυπωσιακά έργα τέχνης που θα καθηλώσουν όλους!</p>
      `
    },
    3: {
      title: 'Γαλλικά Macaron: Οδηγός για Αρχάριους',
      date: '10 Ιανουαρίου 2025',
      image: '/images/3.jpg',
      content: `
        <h2>Η Ιστορία και η Μαγεία των Macaron</h2>
        <p>Τα γαλλικά macaron είναι μικρά γλυκά από αμυγδάλου που έχουν κατακτήσει τον κόσμο με την απαλή, λεπτή κρούστα τους, το μαλακό εσωτερικό, και την πλούσια γέμιση. Αν και φαίνονται απλά, τα macaron απαιτούν ακρίβεια και τεχνική για να επιτευχθεί το τέλειο αποτέλεσμα.</p>

        <h3>Τα Απαραίτητα Υλικά</h3>
        <ul>
          <li>200g αμύγδαλο αλεύρι εξαιρετικά λεπτό</li>
          <li>200g άχνη ζάχαρη</li>
          <li>150g ασπράδια αυγών σε θερμοκρασία δωματίου</li>
          <li>200g ζάχαρη κρυσταλλική</li>
          <li>50ml νερό</li>
          <li>Βρώσιμα χρώματα gel</li>
          <li>Εκχύλισμα βανίλιας ή άλλα αρώματα</li>
        </ul>

        <h3>Η Τεχνική της Ιταλικής Μαρέγκας</h3>
        <p>Η πιο αξιόπιστη μέθοδος για macaron είναι η ιταλική μαρέγκα, που χρησιμοποιεί ζεστό σιρόπι ζάχαρης. Αυτή η τεχνική παρέχει σταθερότητα και σίγουρο αποτέλεσμα.</p>

        <h2>Βήματα Επιτυχίας</h2>
        <div class="chart-container">
          <h3>Κρίσιμα Σημεία στη Διαδικασία</h3>
          <div class="chart-bars">
            <div class="chart-bar" style="height: 70%;">
              <span class="chart-value">70%</span>
              <span class="chart-label">Μαρέγκα</span>
            </div>
            <div class="chart-bar" style="height: 85%;">
              <span class="chart-value">85%</span>
              <span class="chart-label">Macaronage</span>
            </div>
            <div class="chart-bar" style="height: 60%;">
              <span class="chart-value">60%</span>
              <span class="chart-label">Στέγνωμα</span>
            </div>
            <div class="chart-bar" style="height: 90%;">
              <span class="chart-value">90%</span>
              <span class="chart-label">Ψήσιμο</span>
            </div>
            <div class="chart-bar" style="height: 50%;">
              <span class="chart-value">50%</span>
              <span class="chart-label">Γέμιση</span>
            </div>
          </div>
        </div>

        <h3>Βήμα 1: Προετοιμασία Ξηρών Υλικών</h3>
        <p>Κοσκινίστε μαζί το αμύγδαλο αλεύρι και την άχνη ζάχαρη τουλάχιστον δύο φορές. Αυτό εξασφαλίζει ότι δεν θα υπάρχουν grudges που θα χαλάσουν την λεία επιφάνεια των macaron.</p>

        <h3>Βήμα 2: Ιταλική Μαρέγκα</h3>
        <ul>
          <li>Ζεστάνετε τη ζάχαρη με το νερό μέχρι 118°C</li>
          <li>Χτυπήστε τα ασπράδια μέχρι να σχηματιστούν μαλακές κορυφές</li>
          <li>Προσθέστε σταδιακά το ζεστό σιρόπι ενώ χτυπάτε</li>
          <li>Συνεχίστε το χτύπημα μέχρι η μαρέγκα να κρυώσει</li>
          <li>Προσθέστε το χρώμα στο τέλος</li>
        </ul>

        <h3>Βήμα 3: Η Κρίσιμη Διαδικασία Macaronage</h3>
        <p>Αυτό είναι το πιο σημαντικό βήμα. Προσθέστε τα ξηρά υλικά στη μαρέγκα και αναδέψτε με προσοχή χρησιμοποιώντας κίνηση αναδίπλωσης. Το μείγμα είναι έτοιμο όταν κυλάει από τη μαρίζ σαν κορδέλα και επανέρχεται στην επιφάνεια μέσα σε 10-15 δευτερόλεπτα.</p>

        <h3>Βήμα 4: Σχηματισμός και Στέγνωμα</h3>
        <p>Χρησιμοποιήστε σακούλα με στρογγυλή μύτη για να σχηματίσετε κυκλικά macaron διαμέτρου 3-4cm. Αφήστε τα να στεγνώσουν σε θερμοκρασία δωματίου για 30-60 λεπτά μέχρι να σχηματιστεί λεπτή κρούστα που δεν κολλάει όταν την αγγίζετε.</p>

        <h3>Βήμα 5: Ψήσιμο</h3>
        <p>Ψήστε στους 150°C για 12-15 λεπτά. Τα macaron είναι έτοιμα όταν μπορείτε να τα σηκώσετε απαλά από το χαρτί χωρίς να κολλήσουν. Το χαρακτηριστικό pied δείχνει τέλεια ψήσιμο.</p>

        <h3>Γεμίσεις που Συναρπάζουν</h3>
        <ul>
          <li>Ganache σοκολάτας με διάφορες ποσοστώσεις κακάο</li>
          <li>Buttercream με φυσικά αρώματα</li>
          <li>Μαρμελάδες φρούτων υψηλής ποιότητας</li>
          <li>Caramel με θαλασσινό αλάτι</li>
          <li>Κρέμα λεμονιού ή φρούτων του πάθους</li>
        </ul>

        <h3>Συνηθισμένα Λάθη και Λύσεις</h3>
        <p>Ρωγμασμένες επιφάνειες: Υπερβολικό ψήσιμο ή ανεπαρκής στέγνωμα. Κούφια macaron: Υπερβολικό macaronage ή πολύ γρήγορο ψήσιμο. Απουσία pied: Ανεπαρκής στέγνωμα ή πολύ χαμηλή θερμοκρασία φούρνου.</p>

        <p>Με πρακτική και υπομονή, θα κατακτήσετε την τέχνη των macaron και θα δημιουργείτε επαγγελματικά αποτελέσματα!</p>
      `
    },
    4: {
      title: 'Σοκολατένιες Δημιουργίες που Εντυπωσιάζουν',
      date: '8 Ιανουαρίου 2025',
      image: '/images/4.jpg',
      content: `
        <h2>Ο Μαγικός Κόσμος της Σοκολάτας</h2>
        <p>Η σοκολάτα είναι ένα από τα πιο αγαπημένα υλικά στη ζαχαροπλαστική, και όχι χωρίς λόγο. Η πλούσια γεύση της, η βελούδινη υφή της, και οι απεριόριτες δυνατότητες εφαρμογής την καθιστούν απαραίτητη για κάθε pastry chef.</p>

        <h3>Τύποι Σοκολάτας και Χρήσεις</h3>
        <ul>
          <li>Μαύρη σοκολάτα 70-85%: Για έντονη γεύση και ganache</li>
          <li>Γάλακτος σοκολάτα 35-45%: Για απαλότερες δημιουργίες</li>
          <li>Λευκή σοκολάτα: Για διακοσμητικά στοιχεία και mousse</li>
          <li>Couverture σοκολάτα: Για tempering και επικάλυψη</li>
          <li>Κακάο σκόνη: Για πλούσια γεύση χωρίς λίπος</li>
        </ul>

        <h3>Η Τέχνη του Tempering</h3>
        <p>Το tempering είναι η διαδικασία ελεγχόμενης θέρμανσης και ψύξης της σοκολάτας για να αποκτήσει σταθερή κρυσταλλική δομή. Αυτό εξασφαλίζει γυαλιστερή επιφάνεια, ικανοποιητικό κράκ, και αντοχή στη θερμοκρασία.</p>

        <h2>Θερμοκρασίες Tempering</h2>
        <div class="chart-container">
          <h3>Διαδικασία Tempering για Κάθε Τύπο</h3>
          <div class="chart-bars">
            <div class="chart-bar" style="height: 90%;">
              <span class="chart-value">50°C</span>
              <span class="chart-label">Λιώσιμο</span>
            </div>
            <div class="chart-bar" style="height: 55%;">
              <span class="chart-value">27°C</span>
              <span class="chart-label">Ψύξη Μαύρης</span>
            </div>
            <div class="chart-bar" style="height: 65%;">
              <span class="chart-value">32°C</span>
              <span class="chart-label">Εργασίας Μαύρης</span>
            </div>
            <div class="chart-bar" style="height: 50%;">
              <span class="chart-value">26°C</span>
              <span class="chart-label">Ψύξη Γάλακτος</span>
            </div>
            <div class="chart-bar" style="height: 60%;">
              <span class="chart-value">30°C</span>
              <span class="chart-label">Εργασίας Γάλακτος</span>
            </div>
          </div>
        </div>

        <h3>Μέθοδοι Tempering</h3>
        <p>Υπάρχουν τρεις κύριες μέθοδοι: η κλασική μέθοδος με μαρμάρινη επιφάνεια, η μέθοδος με σπορά, και η χρήση μηχανήματος tempering. Κάθε μέθοδος έχει τα πλεονεκτήματά της.</p>

        <h3>Δημιουργία Ganache</h3>
        <p>Η ganache είναι ένα γαλάκτωμα σοκολάτας και κρέμας γάλακτος που μπορεί να χρησιμοποιηθεί ως γέμιση, επικάλυψη, ή βάση για τρούφες. Η βασική αναλογία είναι 1:1, αλλά μπορεί να προσαρμοστεί ανάλογα με τη χρήση.</p>

        <h3>Συνταγή Τέλειας Ganache</h3>
        <ul>
          <li>300g σοκολάτα υψηλής ποιότητας κομμένη ψιλά</li>
          <li>300ml κρέμα γάλακτος 35% λιπαρά</li>
          <li>30g βούτυρο σε θερμοκρασία δωματίου</li>
          <li>Προαιρετικά: αρώματα, αλκοόλ, ή εσπεριδοειδή</li>
        </ul>

        <h3>Διαδικασία Παρασκευής</h3>
        <p>Ζεστάνετε την κρέμα μέχρι το σημείο βρασμού. Αφαιρέστε από τη φωτιά και προσθέστε τη σοκολάτα. Αφήστε για 2 λεπτά, στη συνέχεια ανακατέψτε από το κέντρο προς τα έξω μέχρι να γίνει λεία και γυαλιστερή. Προσθέστε το βούτυρο και τυχόν αρώματα όταν η θερμοκρασία πέσει στους 40°C.</p>

        <h3>Σοκολατένια Διακοσμητικά</h3>
        <p>Με tempared σοκολάτα μπορείτε να δημιουργήσετε εντυπωσιακά διακοσμητικά στοιχεία: cigarettes, shards, curls, και λεπτά φύλλα. Χρησιμοποιήστε ξύστρα λαχανικών για σγουρούς ρόλους, μαχαίρι ζύμης για φύλλα, και καλούπια για φιγούρες.</p>

        <h3>Mousse Σοκολάτας</h3>
        <p>Η mousse σοκολάτας συνδυάζει την πλούσια γεύση της σοκολάτας με αέρινη υφή. Η βάση είναι ganache ενισχυμένη με μαρέγκα ή μαστιχωτή κρέμα. Το κλειδί είναι η σωστή αναδίπλωση για να διατηρηθεί ο αέρας.</p>

        <h3>Πραλίνες και Τρούφες</h3>
        <p>Οι χειροποίητες πραλίνες απαιτούν ακρίβεια και υπομονή. Αρχίστε με απλές τρούφες ganache, στη συνέχεια προχωρήστε σε πληρωμένες πραλίνες με διάφορες γεμίσεις: caramel, φρούτων, ξηρούς καρπούς, ή λικέρ.</p>

        <h3>Συμβουλές Αποθήκευσης</h3>
        <p>Η σοκολάτα πρέπει να φυλάσσεται σε δροσερό, ξηρό μέρος, μακριά από έντονες οσμές. Η ιδανική θερμοκρασία είναι 15-18°C με υγρασία κάτω από 50%. Αποφύγετε το ψυγείο εκτός αν είναι απόλυτα αναγκαίο.</p>

        <p>Με αυτές τις γνώσεις και λίγη πρακτική, θα μπορείτε να δημιουργείτε σοκολατένια αριστουργήματα που θα ενθουσιάσουν!</p>
      `
    },
    5: {
      title: 'Ζύμες Σφολιάτας: Από το Βασικό στο Προχωρημένο',
      date: '5 Ιανουαρίου 2025',
      image: '/images/5.jpg',
      content: `
        <h2>Η Τέχνη της Σφολιάτας</h2>
        <p>Η ζύμη σφολιάτας είναι ένα από τα πιο εντυπωσιακά επιτεύγματα της ζαχαροπλαστικής και της αρτοποιίας. Με εκατοντάδες λεπτά στρώματα που δημιουργούνται μέσω διπλώσεων και ελάσεων, η σφολιάτα μετατρέπεται κατά το ψήσιμο σε αέρινη, τραγανή απόλαυση.</p>

        <h3>Τα Μυστικά της Επιτυχίας</h3>
        <ul>
          <li>Χρησιμοποιήστε βούτυρο υψηλής ποιότητας με τουλάχιστον 82% λίπος</li>
          <li>Διατηρήστε όλα τα υλικά κρύα καθ όλη τη διαδικασία</li>
          <li>Εργαστείτε σε δροσερό περιβάλλον</li>
          <li>Μην βιαστείτε, η υπομονή είναι κλειδί</li>
          <li>Σεβαστείτε τους χρόνους ανάπαυσης στο ψυγείο</li>
        </ul>

        <h3>Βασική Συνταγή Σφολιάτας</h3>
        <p>Για περίπου 1kg ζύμης σφολιάτας χρειάζεστε: 500g αλεύρι για όλες τις χρήσεις, 10g αλάτι, 250ml παγωμένο νερό, 25g λιωμένο βούτυρο για τη ζύμη, και 350g κρύο βούτυρο για τις διπλώσεις.</p>

        <h2>Στάδια Δημιουργίας Σφολιάτας</h2>
        <div class="chart-container">
          <h3>Χρόνος για Κάθε Φάση</h3>
          <div class="chart-bars">
            <div class="chart-bar" style="height: 30%;">
              <span class="chart-value">30min</span>
              <span class="chart-label">Ζύμη</span>
            </div>
            <div class="chart-bar" style="height: 60%;">
              <span class="chart-value">60min</span>
              <span class="chart-label">Ανάπαυση</span>
            </div>
            <div class="chart-bar" style="height: 90%;">
              <span class="chart-value">90min</span>
              <span class="chart-label">Διπλώσεις</span>
            </div>
            <div class="chart-bar" style="height: 40%;">
              <span class="chart-value">40min</span>
              <span class="chart-label">Διαμόρφωση</span>
            </div>
            <div class="chart-bar" style="height: 50%;">
              <span class="chart-value">50min</span>
              <span class="chart-label">Ψήσιμο</span>
            </div>
          </div>
        </div>

        <h3>Παρασκευή της Βασικής Ζύμης</h3>
        <p>Ανακατέψτε το αλεύρι με το αλάτι. Προσθέστε το λιωμένο βούτυρο και το παγωμένο νερό. Ζυμώστε ελαφρώς μόνο μέχρι να ενωθούν τα υλικά, χωρίς να αναπτυχθεί η γλουτένη. Σχηματίστε σε δίσκο, τυλίξτε και αφήστε στο ψυγείο για 30 λεπτά.</p>

        <h3>Προετοιμασία του Βουτύρου</h3>
        <p>Χτυπήστε το κρύο βούτυρο ελαφρά με την κυλινδρική βάση για να γίνει εύπλαστο αλλά όχι μαλακό. Σχηματίστε το σε τετράγωνο περίπου 15x15cm. Η συνέπεια του βουτύρου πρέπει να είναι παρόμοια με αυτή της ζύμης.</p>

        <h3>Η Διαδικασία των Διπλώσεων</h3>
        <p>Απλώστε τη ζύμη σε ορθογώνιο διπλάσιο του μεγέθους του βουτύρου. Τοποθετήστε το βούτυρο στο κέντρο και διπλώστε τη ζύμη πάνω από αυτό σαν φάκελο. Σφραγίστε τις άκρες.</p>

        <h3>Τα Τρία Είδη Διπλώσεων</h3>
        <ul>
          <li>Απλή διπλώση: Διπλώστε τη ζύμη στα τρία σαν επιστολή (3 στρώματα)</li>
          <li>Διπλή διπλώση: Διπλώστε τα άκρα στο κέντρο και στη συνέχεια στη μέση (4 στρώματα)</li>
          <li>Υβριδική: Συνδυασμός των δύο παραπάνω</li>
        </ul>

        <h3>Πρόγραμμα Διπλώσεων</h3>
        <p>Για κλασική σφολιάτα, κάντε 6 απλές διπλώσεις με ανάπαυση 30 λεπτών μεταξύ κάθε δύο διπλώσεων. Αυτό δημιουργεί 729 στρώματα. Για πιο αέρινη σφολιάτα, μπορείτε να φτάσετε έως 8 διπλώσεις.</p>

        <h3>Τεχνικές Ψησίματος</h3>
        <p>Προθερμάνετε τον φούρνο στους 220°C. Βουρτσίστε τη σφολιάτα με αυγό για γυαλάδα. Ψήστε για 15-20 λεπτά ή μέχρι να γίνει χρυσαφένια και τραγανή. Μην ανοίγετε την πόρτα του φούρνου τα πρώτα 15 λεπτά.</p>

        <h3>Δημιουργίες με Σφολιάτα</h3>
        <p>Με τη βασική σφολιάτα μπορείτε να φτιάξετε: κλασικά palmiers, vol-au-vents, mille-feuille, croissants, pain au chocolat, τάρτες, και πολλά άλλα. Κάθε δημιουργία απαιτεί ελαφρώς διαφορετική τεχνική διαμόρφωσης.</p>

        <h3>Παραλλαγές Σφολιάτας</h3>
        <ul>
          <li>Σφολιάτα με αμύγδαλο για pithiviers</li>
          <li>Σοκολατένια σφολιάτα για pain au chocolat</li>
          <li>Αλμυρή σφολιάτα με τυριά και βότανα</li>
          <li>Σφολιάτα ολικής άλεσης για πιο υγιεινές επιλογές</li>
        </ul>

        <h3>Αποθήκευση και Κατάψυξη</h3>
        <p>Η ψημένη σφολιάτα διατηρείται για 2-3 ημέρες σε αεροστεγές δοχείο. Η άψητη ζύμη μπορεί να καταψυχθεί για έως 3 μήνες. Απομυθοποιήστε στο ψυγείο πριν τη χρήση.</p>

        <h3>Συνηθισμένα Προβλήματα και Λύσεις</h3>
        <p>Βούτυρο που λιώνει: Η ζύμη ή το περιβάλλον είναι πολύ ζεστό. Ανομοιόμορφο ψήσιμο: Ανεπαρκής ανάπαυση ή άνιση πίεση κατά την έλαση. Σκληρή σφολιάτα: Υπερβολική ανάπτυξη γλουτένης ή πολύ μεγάλο ψήσιμο.</p>

        <p>Η σφολιάτα απαιτεί πρακτική, αλλά τα αποτελέσματα αξίζουν κάθε προσπάθεια. Με υπομονή και προσοχή στη λεπτομέρεια, θα δημιουργείτε επαγγελματικού επιπέδου σφολιάτες!</p>
      `
    }
  };

  const post = posts[id];

  const handleShare = () => {
    setShowShareModal(true);
    setTimeout(() => setShowShareModal(false), 2000);
  };

  const handleFavorite = () => {
    setIsFavorite(!isFavorite);
    setShowFavoriteModal(true);
    setTimeout(() => setShowFavoriteModal(false), 2000);
  };

  if (!post) {
    return (
      <div className="post-detail-container">
        <div className="about-hero">
          <h1>Το άρθρο δεν βρέθηκε</h1>
          <Link to="/" className="cta-button">Επιστροφή στην Αρχική</Link>
        </div>
      </div>
    );
  }

  return (
    <>
            <Helmet>
        <title>Neralen - Ζαχαροπλαστική Τέχνη</title>
        <meta name="description" content="Neralen - Ανακαλύψτε τον κόσμο της ζαχαροπλαστικής τέχνης με αυθεντικές συνταγές και επαγγελματικές συμβουλές" />
      </Helmet>

<div className="post-detail-container">
        <div className="post-detail">
          <img src={post.image} alt={post.title} className="post-detail-image" />
          <div className="post-detail-content">
            <h1>{post.title}</h1>
            <div className="post-detail-meta">
              <FaShoppingCart /> Δημοσιεύτηκε στις {post.date}
            </div>
            <div 
              className="post-detail-text" 
              dangerouslySetInnerHTML={{ __html: post.content }}
            />
            <div className="post-actions">
              <Link to="/" className="btn btn-primary">
                <FaHome /> Επιστροφή στην Αρχική
              </Link>
              <button onClick={handleShare} className="btn btn-secondary">
                Κοινοποίηση
              </button>
              <button 
                onClick={handleFavorite} 
                className={`btn btn-favorite ${isFavorite ? 'active' : ''}`}
              >
                <FaHeart /> {isFavorite ? 'Αγαπημένο' : 'Προσθήκη'}
              </button>
            </div>
          </div>
        </div>
      </div>

      {showShareModal && (
        <div className="modal">
          <div className="modal-content">
            <h2>Κοινοποίηση</h2>
            <p>Η λειτουργία κοινοποίησης θα είναι διαθέσιμη σύντομα!</p>
          </div>
        </div>
      )}

      {showFavoriteModal && (
        <div className="modal">
          <div className="modal-content">
            <h2>Αγαπημένα</h2>
            <p>{isFavorite ? 'Το άρθρο προστέθηκε στα αγαπημένα σας!' : 'Το άρθρο αφαιρέθηκε από τα αγαπημένα σας!'}</p>
          </div>
        </div>
      )}
    </>
  );
}

export default PostDetail;